import React from "react";

function ApiResponseHandler(response, notificationCtx, navigate){

    if(response.status === 200){
        notificationCtx.success('Updated Successfully');
    }
    else if(response.status === 401 || response.status === 403){
        notificationCtx.error('Unauthorized. Please log-in.');
        navigate('/');
    }
    // else if(response.status === 404){
    //     notificationCtx.error(response.status + ': ' + response.statusText);
    //     navigate('/server-error');
    // }
    // else if(response.status > 500){
    //     notificationCtx.error(response.status + ': ' + response.statusText);
    //     navigate('/server-error');
    // }
    else{
        notificationCtx.error(response.status + ': ' + response.statusText);
    }
    setTimeout(() => {
        notificationCtx.clear();
    }, 3000);
}
export default ApiResponseHandler;